module.exports = __webpack_public_path__ + "static/case-study-3-3bee4e4c01e10b13118df5a75e1c9f83.png";